// ═══════════════════════════════════════════════════════════
// RBAC Type Definitions
// ═══════════════════════════════════════════════════════════

export type PermissionLevel = 'none' | 'viewer' | 'editor' | 'admin';

export type ModuleId =
  | 'hotwash' | 'handoff' | 'rollcall' | 'geoops'
  | 'impact' | 'intake' | 'battlerhythm' | 'pace'
  | 'volunteer' | 'mainstreet' | 'filelibrary' | 'blackboard' | 'incidents'
  | 'debris' | 'shelter' | 'pagrants' | 'timelabor' | 'workflows' | 'forms';

export const ALL_MODULE_IDS: ModuleId[] = [
  'hotwash', 'handoff', 'rollcall', 'geoops',
  'impact', 'intake', 'battlerhythm', 'pace',
  'volunteer', 'mainstreet', 'filelibrary', 'blackboard', 'incidents',
  'debris', 'shelter', 'pagrants', 'timelabor', 'workflows', 'forms',
];

export type RbacPermissions = Record<ModuleId, PermissionLevel>;

export interface Role {
  id: number;
  roleName: string;
  roleSlug: string;
  description: string;
  permissions: RbacPermissions;
  isDefault: boolean;
  sortOrder: number;
}

export interface UserRole {
  id: number;
  userEmail: string;
  userName: string;
  roleId: string;
  roleName: string;
  assignedBy: string;
}

export interface ModuleAccess {
  level: PermissionLevel;
  canView: boolean;
  canEdit: boolean;
  canAdmin: boolean;
}

const LEVEL_ORDER: Record<PermissionLevel, number> = { none: 0, viewer: 1, editor: 2, admin: 3 };

export function hasMinLevel(actual: PermissionLevel, required: PermissionLevel): boolean {
  return LEVEL_ORDER[actual] >= LEVEL_ORDER[required];
}

export function computeAccess(level: PermissionLevel): ModuleAccess {
  return {
    level,
    canView: hasMinLevel(level, 'viewer'),
    canEdit: hasMinLevel(level, 'editor'),
    canAdmin: hasMinLevel(level, 'admin'),
  };
}
